import { useEffect, useReducer } from 'react'

import { AccordionDispatchContext, AccordionStateContext } from './context'
import { initialState, reducer, reset } from './reducer'

export const AccordionProvider = ({ allowMultiple, defaultOpenKeys, children }) => {
  const [state, dispatch] = useReducer(reducer, initialState({
    selectedKeys: defaultOpenKeys,
    allowMultiple
  }))

  useEffect(() => {
    dispatch(reset({
      selectedKeys: defaultOpenKeys,
      allowMultiple
    }))
  }, [allowMultiple, defaultOpenKeys])

  return (
    <AccordionStateContext.Provider value={state}>
      <AccordionDispatchContext.Provider value={dispatch}>
        {children}
      </AccordionDispatchContext.Provider>
    </AccordionStateContext.Provider>
  )
}
